const fabHomepageEditorConfig = {
  initialContent: {
    hero_title: "",
    hero_subtitle: "",
    hero_button_label: "EXPLORE",
    hero_button_link: "",

    intro_text: "",
    section_two_text: "",
    section_three_text: "",
    section_four_text: "",

    hero_image_url: "",
    second_hero_image_url: "",
    third_hero_image_url: "",
    fourth_hero_image_url: "",
    gallery_images: [],
  },

imageFields: {
  hero: {
    contentKey: "hero_image_url",
  },

  secondHero: {
    contentKey: "second_hero_image_url",
  },

  thirdHero: {
    contentKey: "third_hero_image_url",
  },

  fourthHero: {
    contentKey: "fourth_hero_image_url",
  },
},

galleryFields: {
  galleryImageFiles: {
    contentKey: "gallery_images",
    removeField: "removeGalleryImages",
  },
},

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,

      section_four_text: Array.isArray(content.section_four_lines)
        ? content.section_four_lines.join("\n")
        : content.section_four_text || "",

      gallery_images: Array.isArray(content.gallery_images)
        ? content.gallery_images
        : [],
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      hero_title: templateState.hero_title?.trim() || "",
      hero_subtitle: templateState.hero_subtitle?.trim() || "",
      hero_button_label:
        templateState.hero_button_label?.trim() || "EXPLORE",
      hero_button_link:
        templateState.hero_button_link?.trim() || "",

      intro_text: templateState.intro_text?.trim() || "",
      section_two_text:
        templateState.section_two_text?.trim() || "",
      section_three_text:
        templateState.section_three_text?.trim() || "",

      section_four_lines: templateState.section_four_text
        ? templateState.section_four_text
            .split("\n")
            .map((line) => line.trim())
            .filter(Boolean)
        : [],

hero_image_url:
  sharedState.resolvedImageUrls?.hero || "",

second_hero_image_url:
  sharedState.resolvedImageUrls?.secondHero || "",

third_hero_image_url:
  sharedState.resolvedImageUrls?.thirdHero || "",

fourth_hero_image_url:
  sharedState.resolvedImageUrls?.fourthHero || "",

gallery_images: Array.isArray(
  sharedState.resolvedGalleryImageUrls?.galleryImageFiles
)
  ? sharedState.resolvedGalleryImageUrls.galleryImageFiles
  : [],
    };
  },

getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,

getGalleryField,
setGalleryFiles,
setGalleryRemoved,
setGalleryExistingUrls,
}) {
  const hero = getImageField("hero");
  const secondHero = getImageField("secondHero");
  const thirdHero = getImageField("thirdHero");
  const fourthHero = getImageField("fourthHero");
const gallery = getGalleryField("galleryImageFiles");
  return {
    templateState,
    setTemplateField,

    heroImageFile: hero.file,
    setHeroImageFile: (file) =>
      setImageFile("hero", file),
    existingHeroImageUrl: hero.existingUrl,
    removeHeroImage: hero.remove,
    setRemoveHeroImage: (remove) =>
      setImageRemoved("hero", remove),

    secondHeroImageFile: secondHero.file,
    setSecondHeroImageFile: (file) =>
      setImageFile("secondHero", file),
    existingSecondHeroImageUrl: secondHero.existingUrl,
    removeSecondHeroImage: secondHero.remove,
    setRemoveSecondHeroImage: (remove) =>
      setImageRemoved("secondHero", remove),

    thirdHeroImageFile: thirdHero.file,
    setThirdHeroImageFile: (file) =>
      setImageFile("thirdHero", file),
    existingThirdHeroImageUrl: thirdHero.existingUrl,
    removeThirdHeroImage: thirdHero.remove,
    setRemoveThirdHeroImage: (remove) =>
      setImageRemoved("thirdHero", remove),

    fourthHeroImageFile: fourthHero.file,
    setFourthHeroImageFile: (file) =>
      setImageFile("fourthHero", file),
    existingFourthHeroImageUrl: fourthHero.existingUrl,
    removeFourthHeroImage: fourthHero.remove,
    setRemoveFourthHeroImage: (remove) =>
      setImageRemoved("fourthHero", remove),

galleryImageFiles: gallery.files,

setGalleryImageFiles: (valueOrUpdater) => {
  const nextFiles =
    typeof valueOrUpdater === "function"
      ? valueOrUpdater(gallery.files)
      : valueOrUpdater;

  setGalleryFiles("galleryImageFiles", nextFiles);
},

existingGalleryImageUrls: gallery.existingUrls,

setExistingGalleryImageUrls: (valueOrUpdater) =>
  setGalleryExistingUrls(
    "galleryImageFiles",
    valueOrUpdater
  ),

removeGalleryImages: gallery.remove,

setRemoveGalleryImages: (remove) =>
  setGalleryRemoved("galleryImageFiles", remove),
  };
},
};

export default fabHomepageEditorConfig;